import { useState, useEffect } from 'react';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

import PdfMergerApp from './components/PdfMergerApp';
import LegalPage from './components/LegalPage';
import LandingPage from './components/LandingPage';
import { CookieConsentProvider, useCookieConsent } from './context/CookieConsentContext';
import CookieBanner from './components/CookieBanner';

const AppContent = () => {
  const [currentPage, setCurrentPage] = useState('landing');
  const { isConsentGiven } = useCookieConsent();

  useEffect(() => {
    if (isConsentGiven) {
      console.log('Consent granted - initializing Google Analytics...');

      // Load GA script
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=G-LGYRC32BT2`;
      script.async = true;
      document.head.appendChild(script);

      // Initialize GA
      window.dataLayer = window.dataLayer || [];
      function gtag(...args: any[]) { window.dataLayer.push(args); }
      gtag('js', new Date());
      gtag('config', 'G-LGYRC32BT2');
    }
  }, [isConsentGiven]);

  const renderPage = () => {
    switch (currentPage) {
      case 'app':
        return <PdfMergerApp onNavigate={setCurrentPage} />;
      case 'terms':
        return <LegalPage page="terms" onNavigate={setCurrentPage} />;
      case 'privacy':
        return <LegalPage page="privacy" onNavigate={setCurrentPage} />;
      case 'cookies':
        return <LegalPage page="cookies" onNavigate={setCurrentPage} />;
      case 'accessibility':
        return <LegalPage page="accessibility" onNavigate={setCurrentPage} />;
      default:
        return <LandingPage onNavigate={setCurrentPage} />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {renderPage()}
      <CookieBanner />
    </div>
  );
};

function App() {
  return (
    <CookieConsentProvider>
      <AppContent />
    </CookieConsentProvider>
  );
}

export default App;